/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/nb_NO';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Få tilgang til Elegante HTML-redigering"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Tilgjengelighetsquizer"
  },
  "action_to_take_b626a99a": {
    "message": "Handling å utføre:"
  },
  "add_8523c19b": {
    "message": "Legg til"
  },
  "add_a_caption_2a915239": {
    "message": "Legg til overskrift"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Legg til alternativ tekst for bildet"
  },
  "add_another_f4e50d57": {
    "message": "Legg til en annen"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Legg til CC/Undertekst"
  },
  "add_image_60b2de07": {
    "message": "Legg til bilde"
  },
  "add_one_9e34a6f8": {
    "message": "Legg til en!"
  },
  "additional_considerations_f3801683": {
    "message": "Ekstra hensyn"
  },
  "address_applied_64269b0b": {
    "message": "Adresse aktivert"
  },
  "address_removed_fcb496e0": {
    "message": "Adresse fjernet"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Lenker ved siden av hverandre med samme URL bør være samme lenke."
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "Tilpass"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Tilpasning og lister"
  },
  "all_4321c3a1": {
    "message": "Alle"
  },
  "all_apps_a50dea49": {
    "message": "Alle apper"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Tillat nedlasting av media"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Tillat nedlasting av transkripsjon"
  },
  "alpha_15d59033": {
    "message": "Alfa"
  },
  "alphabetical_55b5b4e0": {
    "message": "Alfabetisk"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Alt-attributter bør ikke inneholde mer enn 120 tegn."
  },
  "alt_text_611fb322": {
    "message": "Endre tekst"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (biprodukt)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Det oppsto en feil ved lesing av filen"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Det oppsto en feil ved utførelse av en nettverksforespørsel"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Det oppsto en feil ved opplasting av media."
  },
  "and_7fcc2911": {
    "message": "Og"
  },
  "angle_c5b4ec50": {
    "message": "Vinkel"
  },
  "announcement_fb4cb645": {
    "message": "Beskjed"
  },
  "announcement_list_da155734": {
    "message": "Beskjedsliste"
  },
  "announcements_a4b8ed4a": {
    "message": "Beskjeder"
  },
  "apply_781a2546": {
    "message": "Bruk"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Bruk endringer på alle forekomster av denne Ikonskaper-ikonet i faget"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Nærmer seg grensen"
  },
  "approximately_e7965800": {
    "message": "Omtrent"
  },
  "apps_54d24a47": {
    "message": "Apper"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Er du sikker på at du vil avbryte? Det kan hende at endringene dine ikke ble lagret."
  },
  "arrows_464a3e54": {
    "message": "Piler"
  },
  "art_icon_8e1daad": {
    "message": "Kunstikon"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Dimensjonene vil bli bevart"
  },
  "assignment_976578a8": {
    "message": "Oppgave"
  },
  "assignments_1e02582c": {
    "message": "Oppgaver"
  },
  "asterisk_82255584": {
    "message": "Stjerne"
  },
  "attributes_963ba262": {
    "message": "Attributter"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Lyd- og videoopptak støttes ikke, bruk en annen nettleser."
  },
  "audio_options_feb58e2c": {
    "message": "Lydalternativer"
  },
  "audio_options_tray_33a90711": {
    "message": "Brett for lydalternativer"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Lydspiller for { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Automatisk lagret innhold finnes. Ønsker du å laste det automatisk lagrede innholdet i stedet?"
  },
  "available_folders_694d0436": {
    "message": "Tilgjengelige mapper"
  },
  "background_1bc88842": {
    "message": "Bakgrunn"
  },
  "backslash_b2d5442d": {
    "message": "Bakstrek"
  },
  "bar_ec63ed6": {
    "message": "Linje"
  },
  "basic_554cdc0a": {
    "message": "Basic"
  },
  "because_501841b": {
    "message": "Fordi"
  },
  "below_81d4dceb": {
    "message": "Under"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Stor sirkel"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Binomial koeffisient"
  },
  "black_4cb01371": {
    "message": "Svart"
  },
  "blue_daf8fea9": {
    "message": "Blå"
  },
  "bold_applied_42d547b7": {
    "message": "Fet aktivert"
  },
  "bold_removed_da474a5c": {
    "message": "Fet fjernet"
  },
  "border_5b08b06d": {
    "message": "Ramme"
  },
  "bottom_15a2a9be": {
    "message": "Bunn"
  },
  "bottom_third_5f5fec1d": {
    "message": "Nedre tredjedel"
  },
  "bowtie_5f9629e4": {
    "message": "Sløyfe"
  },
  "brick_f2656265": {
    "message": "Blokk"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Avbryt"
  },
  "cap_product_3a5265a6": {
    "message": "Capsprodukt"
  },
  "caption_manager_aae0906f": {
    "message": "Bildetekstadministrator"
  },
  "center_align_e68d9997": {
    "message": "Midtstilt"
  },
  "centered_dot_64d5e378": {
    "message": "Sentrert prikk"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Sentrerte horisontale prikker"
  },
  "change_alt_text_92654906": {
    "message": "Endre alternativ tekst"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Endre titteltag til setning"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Endre bare denne overskriftens nivå"
  },
  "change_text_color_1aecb912": {
    "message": "Endre tekstfarge"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "Endringene gjelder dersom du lagrer denne siden."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Det kan hende at endringene dine ikke ble lagret."
  },
  "characters_9d897d1c": {
    "message": "Tegn"
  },
  "characters_no_spaces_485e5367": {
    "message": "Tegn (ingen mellomrom)"
  },
  "check_accessibility_3c78211c": {
    "message": "Quiz tilgjengelighet"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Quizer for tilgjengelighetsproblemer"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Velg undertekst-fil"
  },
  "choose_usage_rights_33683854": {
    "message": "Velg bruksrettigheter…"
  },
  "circle_484abe63": {
    "message": "Sirkel"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "sirkel uordnet liste"
  },
  "clear_2084585f": {
    "message": "Tøm"
  },
  "clear_image_3213fe62": {
    "message": "Fjern bilde"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Klikk eller skift-klikk for html-redigeringsprogrammet."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Klikk for å bygge inn { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Klikk for å skjule forhåndsvisning"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Klikk for å sette inn en kobling i redigeringsprogrammet."
  },
  "click_to_show_preview_faa27051": {
    "message": "Klikk for å vise forhåndsvisning"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Lukk en meny eller dialog. Returnerer deg også til redigeringsområdet"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Lukk tilgjengelighetsquizer"
  },
  "close_d634289d": {
    "message": "Lukk"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "Lukk Tastatursnarveier-modalen"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Fil med teksting må være mindre enn { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Undertekster"
  },
  "clubs_suit_c1ffedff": {
    "message": "Kløver (type)"
  },
  "collab_575ac7bc": {
    "message": "Samarbeid"
  },
  "collaborations_5c56c15f": {
    "message": "Samarbeid"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Kollaps for å skjule { types }"
  },
  "color_a363e1b0": {
    "message": "Farge"
  },
  "color_contrast_4c418add": {
    "message": "Fargekontrast"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Fargekontrastforhold"
  },
  "color_picker_6b359edf": {
    "message": "Fargevelger"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Fargevelger ({ colorName } valgt)"
  },
  "color_popup_af39810f": {
    "message": "Farge-popup"
  },
  "column_e1ae5c64": {
    "message": "Kolonne"
  },
  "column_group_1c062368": {
    "message": "Kolonnegruppe"
  },
  "complex_numbers_a543d004": {
    "message": "Komplekse tall"
  },
  "computer_1d7dfa6f": {
    "message": "Datamaskin"
  },
  "congruent_5a244acd": {
    "message": "Kongruent"
  },
  "contains_311f37b7": {
    "message": "Inneholder"
  },
  "content_1440204b": {
    "message": "Innhold"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Innhold i redigeringsprogrammet vil bli endret. Trykk Avbryt for å beholde originalt innhold."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Innhold blir fortsatt lastet opp, fortsetter du vil ikke innholdet bli innebygd riktig."
  },
  "content_subtype_5ce35e88": {
    "message": "Innhold undertype"
  },
  "content_type_2cf90d95": {
    "message": "Innholdstype"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Fortsett til YouTube-innhold"
  },
  "coproduct_e7838082": {
    "message": "Biprodukt"
  },
  "copyright_holder_66ee111": {
    "message": "Rettighetshaver:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Kunne ikke sette inn innhold: «{ itemType }» elementer støttes ikke i Canvas for øyeblikket."
  },
  "count_40eced3b": {
    "message": "Antall"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 ord}\n    one {1 ord}\n  other {# ord}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# element lastet}\n  other {# element lastet}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Fagdokumenter"
  },
  "course_files_62deb8f8": {
    "message": "Filer for fag"
  },
  "course_files_a31f97fc": {
    "message": "Filer for fag"
  },
  "course_images_f8511d04": {
    "message": "Fagbilder"
  },
  "course_link_b369426": {
    "message": "Faglenke"
  },
  "course_links_b56959b9": {
    "message": "Faglenker"
  },
  "course_media_ec759ad": {
    "message": "Fagmedia"
  },
  "course_navigation_dd035109": {
    "message": "Fagnavigasjon"
  },
  "create_icon_110d6463": {
    "message": "Opprett ikon"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Opprett Ikonskaper-ikon"
  },
  "creative_commons_license_725584ae": {
    "message": "Creative Commons-lisens:"
  },
  "crop_image_41bf940c": {
    "message": "Beskjær bilde"
  },
  "crop_image_807ebb08": {
    "message": "Beskjær bilde"
  },
  "cup_product_14174434": {
    "message": "Kopp-produkt"
  },
  "current_image_f16c249c": {
    "message": "Nåværende bilde"
  },
  "current_link_945a47ee": {
    "message": "Gjeldende lenke"
  },
  "current_volume_level_c55ab825": {
    "message": "Gjeldende volumnivå"
  },
  "custom_6979cd81": {
    "message": "Tilpasset"
  },
  "cyan_c1d5f68a": {
    "message": "Cyan"
  },
  "dagger_57e0f4e5": {
    "message": "Dolk"
  },
  "date_added_ed5ad465": {
    "message": "Lagt til dato"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Dekorativt ikon"
  },
  "decorative_image_fde98579": {
    "message": "Dekorativt bilde"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Dekorativt { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Reduser innrykk"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Reduser Rich innholdsområde"
  },
  "deep_purple_bb3e2907": {
    "message": "Mørkelilla"
  },
  "default_9db103d": {
    "message": "Standard"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "standard punkt-uordnet liste"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "standard numerisk-ordnet liste"
  },
  "definite_integral_fe7ffed1": {
    "message": "Bestemt heltall"
  },
  "degree_symbol_4a823d5f": {
    "message": "Gradsymbol"
  },
  "delimiters_4db4840d": {
    "message": "Avgrensninger"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Beskriv ikonet)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Beskriv { TYPE })"
  },
  "description_436c48d7": {
    "message": "Beskrivelse"
  },
  "details_98a31b68": {
    "message": "Detaljer"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Diagonale prikker"
  },
  "diamond_b8dfe7ae": {
    "message": "Diamant"
  },
  "diamonds_suit_526abaaf": {
    "message": "Ruter (type)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Dimensjonstype"
  },
  "directionality_26ae9e08": {
    "message": "Retning"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Rediger LaTex direkte"
  },
  "disable_preview_222bdf72": {
    "message": "Deaktiver forhåndsvisning"
  },
  "discussion_6719c51d": {
    "message": "Diskusjon"
  },
  "discussions_a5f96392": {
    "message": "Diskusjoner"
  },
  "discussions_index_6c36ced": {
    "message": "Diskusjonsindeks"
  },
  "disjoint_union_e74351a8": {
    "message": "Usammenhengende union"
  },
  "display_options_315aba85": {
    "message": "Vis alternativer"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Vis tekstlenke (Åpnes i en ny fane)"
  },
  "div_applied_49ad83fc": {
    "message": "Div aktivert"
  },
  "div_removed_d13f8e17": {
    "message": "Div fjernet"
  },
  "division_sign_72190870": {
    "message": "Deletegn"
  },
  "document_678cd7bf": {
    "message": "Dokument"
  },
  "documents_81393201": {
    "message": "Dokumenter"
  },
  "done_54e3d4b6": {
    "message": "Ferdig"
  },
  "double_dagger_faf78681": {
    "message": "Dobbel dolk"
  },
  "down_5831a426": {
    "message": "Ned"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Diagonal pil ned til venstre"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Diagonal pil ned til høyre"
  },
  "download_filename_2baae924": {
    "message": "Last ned { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Pil nedover"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Trekant som peker nedover"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Dra en fil hit."
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Dra og slipp, eller trykk for å bla i din datamaskin"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Dra-håndtak. Bruk piltastene for å forandre størrelse"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Frist: Flere datoer"
  },
  "due_when_7eed10c6": {
    "message": "Frist: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Rediger alt-tekst for dette ikonet"
  },
  "edit_c5fbea07": {
    "message": "Rediger"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Rediger faglenke"
  },
  "edit_equation_f5279959": {
    "message": "Rediger likning"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Rediger eksisterende Ikonskaper-ikon"
  },
  "edit_icon_2c6b0e91": {
    "message": "Rediger ikon"
  },
  "edit_link_7f53bebb": {
    "message": "Rediger lenke"
  },
  "editor_status_bar_653f44ee": {
    "message": "Statuslinje for redigeringsverktøy"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Element som starter med { start }"
  },
  "embed_828fac4a": {
    "message": "Innebygd"
  },
  "embed_code_314f1bd5": {
    "message": "Integrere kode"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Bygg inn innhold fra eksterne verktøy"
  },
  "embed_image_1080badc": {
    "message": "Bygg inn bilde"
  },
  "embed_video_a97a64af": {
    "message": "Legg ved video"
  },
  "embedded_content_aaeb4d3d": {
    "message": "inkludert innhold"
  },
  "empty_set_91a92df4": {
    "message": "Tomt sett"
  },
  "encircled_dot_8f5e51c": {
    "message": "Omkranset prikk"
  },
  "encircled_minus_72745096": {
    "message": "Omkranset minus"
  },
  "encircled_plus_36d8d104": {
    "message": "Omkranset pluss"
  },
  "encircled_times_5700096d": {
    "message": "Omkransede tider"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Ingeniør-ikon"
  },
  "english_icon_25bfe845": {
    "message": "Engelsk-ikon"
  },
  "enter_a_media_title_81b490ec": {
    "message": "Skriv inn en medietittel"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Skriv inn minst tre tegn for å søke"
  },
  "enter_replacement_text_17631bbc": {
    "message": "skriv inn erstatningstekst"
  },
  "enter_search_text_26cb4459": {
    "message": "skriv inn søketekst"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (variant)"
  },
  "equals_sign_c51bdc58": {
    "message": "Likhetstegn"
  },
  "equation_1c5ac93c": {
    "message": "Ligning"
  },
  "equation_editor_39fbc3f1": {
    "message": "Ligningsredigerer"
  },
  "equilibrium_6ff3040b": {
    "message": "Likevekt"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Ekvivalensklasse"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Ekvivalent (identitet)"
  },
  "eta_b8828f99": {
    "message": "Forventet ankomst"
  },
  "exists_2e62bdaa": {
    "message": "Eksisterer"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Avslutt fullskjerm"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Utvid forhåndsvisning som standard"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Utvid for å se { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Ekstern lenke"
  },
  "external_tool_frame_70b32473": {
    "message": "Ekstern verktøyramme"
  },
  "external_tools_6e77821": {
    "message": "Eksterne verktøy"
  },
  "extra_large_b6cdf1ff": {
    "message": "Ekstra stor"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "Ekstra stor ({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "Ekstra liten"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Utenomfaglig-ikon"
  },
  "f_function_fe422d65": {
    "message": "F (funksjon)"
  },
  "fail_544e5dde": {
    "message": "IKKE BESTÅTT"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Kunne ikke hente filinnhold"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Kunne ikke hente innhold fra eksternt verktøy"
  },
  "file_name_8fd421ff": {
    "message": "Filnavn"
  },
  "file_preview_21667a6e": {
    "message": "Forhåndsvisning av fil"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Forhåndsvisning av fil for { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Tilgjengelig fillagringsplass er overskredet"
  },
  "file_url_c12b64be": {
    "message": "Fil URL"
  },
  "filename_file_icon_602eb5de": {
    "message": "{ filename } filikon"
  },
  "filename_image_preview_6cef8f26": {
    "message": "{ filename } bilde forhåndsvisning"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "{ filename } tekst forhåndsvisning"
  },
  "files_c300e900": {
    "message": "Filer"
  },
  "files_index_af7c662b": {
    "message": "Filindeks"
  },
  "find_8d605019": {
    "message": "Finn"
  },
  "find_and_replace_6e345933": {
    "message": "Finn og erstatt"
  },
  "finish_bc343002": {
    "message": "Ferdig"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Reparer tittelhierarki"
  },
  "flat_music_76d5a5c3": {
    "message": "Flat (musikk)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Verktøylinje for fokuselement-alternativer"
  },
  "folder_tree_fbab0726": {
    "message": "Mappetre"
  },
  "for_all_b919f972": {
    "message": "For alle"
  },
  "format_4247a9c5": {
    "message": "Format"
  },
  "format_as_a_list_142210c3": {
    "message": "Formater som liste"
  },
  "formatting_5b143aa8": {
    "message": "Formatering"
  },
  "forward_slash_3f90f35e": {
    "message": "Skråstrek"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Fant automatisk lagret innhold"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Fant { count, plural,\n     =0 {# resultater}\n    one {# resultat}\n  other {# resultater}\n}"
  },
  "fraction_41bac7af": {
    "message": "Brøkdel"
  },
  "fullscreen_873bf53f": {
    "message": "Fullskjerm"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "Genererer forhåndsvisning…"
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "Bilder i GIF-/PNG-format som er større enn { size } KB støttes ikke for øyeblikket."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Gå til redigeringsmenylinjen"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Gå til redigeringsverktøylinjen"
  },
  "grades_a61eba0a": {
    "message": "Vurderinger"
  },
  "graphics_text_bc9568bc": {
    "message": "Bildetekst"
  },
  "greater_than_e98af662": {
    "message": "Større enn"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Større enn eller lik"
  },
  "greek_65c5b3f7": {
    "message": "Gresk"
  },
  "green_15af4778": {
    "message": "Grønn"
  },
  "grey_a55dceff": {
    "message": "Grå"
  },
  "group_documents_8bfd6ae6": {
    "message": "Gruppedokumenter"
  },
  "group_files_4324f3df": {
    "message": "Gruppefiler"
  },
  "group_files_82e5dcdb": {
    "message": "Gruppefiler"
  },
  "group_images_98e0ac17": {
    "message": "Gruppebilder"
  },
  "group_isomorphism_45b1458c": {
    "message": "Gruppeisomorfi"
  },
  "group_link_63e626b3": {
    "message": "Gruppelenke"
  },
  "group_links_9493129e": {
    "message": "Gruppelenker"
  },
  "group_media_2f3d128a": {
    "message": "Gruppemedia"
  },
  "group_navigation_99f191a": {
    "message": "Gruppenavigering"
  },
  "h_bar_bb94deae": {
    "message": "H-linje"
  },
  "hat_ea321e35": {
    "message": "Hatt"
  },
  "header_column_f27433cb": {
    "message": "Tittelkolonne"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Tittelrad og kolonne"
  },
  "header_row_f33eb169": {
    "message": "Tittelrad"
  },
  "heading_2_5b84eed2": {
    "message": "Overskrift 2"
  },
  "heading_3_2c83de44": {
    "message": "Overskrift 3"
  },
  "heading_4_b2e74be7": {
    "message": "Overskrift 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Tittel { h } aktivert"
  },
  "heading_h_removed_745f24a6": {
    "message": "Tittel { h } fjernet"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Tittelnivåer bør ikke hoppes over"
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Tittel som starter med { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Titler bør ikke inneholde mer enn 120 tegn."
  },
  "health_icon_8d292eb5": {
    "message": "Helse-ikon"
  },
  "hearts_suit_e50e04ca": {
    "message": "Hjerter (type)"
  },
  "height_69b03e15": {
    "message": "Høyde"
  },
  "hexagon_d8468e0d": {
    "message": "Sekskant"
  },
  "hide_description_bfb5502e": {
    "message": "Skjul beskrivelse"
  },
  "hide_title_description_caf092ef": {
    "message": "Skjul { title }-beskrivelse"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Fremhev et element for å aktivere verktøylinjen for elementalternativer"
  },
  "home_351838cd": {
    "message": "Hjem"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "Hvordan be om og redigere teksting?"
  },
  "html_code_editor_fd967a44": {
    "message": "html koderedigeringsprogram"
  },
  "html_editor_fb2ab713": {
    "message": "HTML-redigering"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Jeg har fått tillatelse til å bruke denne filen."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Jeg har opphavsretten"
  },
  "icon_215a1dc6": {
    "message": "Ikon"
  },
  "icon_8168b2f8": {
    "message": "ikonet"
  },
  "icon_color_b86dd6d6": {
    "message": "Ikonfarge"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Ikonskaper-ikoner"
  },
  "icon_options_7e32746e": {
    "message": "Ikonalternativer"
  },
  "icon_options_tray_2b407977": {
    "message": "Brett for ikonalternativer"
  },
  "icon_preview_1782a1d9": {
    "message": "Forhåndsvisning av ikon"
  },
  "icon_shape_30b61e7": {
    "message": "Ikonform"
  },
  "icon_size_9353edea": {
    "message": "Ikonstørrelse"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Hvis lenken er tom, vil tekst vises lenketeksten som navn på faglenken"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Hvis bruksrettigheter kreves, vil filen ikke bli publisert før det er angitt på Filer-siden."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Dersom du ikke velger bruksrettigheter nå, vil denne filen være upublisert når den lastes opp."
  },
  "image_8ad06": {
    "message": "Bilde"
  },
  "image_c1c98202": {
    "message": "bilde"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Bildefilnavn bør ikke brukes som den alt-attributt som beskriver bildeinnholdet."
  },
  "image_options_5412d02c": {
    "message": "Bilde-alternativer"
  },
  "image_options_tray_90a46006": {
    "message": "Brett for bilde-alternativer"
  },
  "image_to_crop_3a34487d": {
    "message": "Bilde som skal beskjæres"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Bilde med filnavn { file }"
  },
  "images_7ce26570": {
    "message": "Bilder"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Bilder burde inneholde en alt-attributt som beskriver bildeinnholdet."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Imaginær del (av komplekst tall)"
  },
  "in_element_of_19ca2f33": {
    "message": "I (element av)"
  },
  "increase_indent_6af90f7c": {
    "message": "Øk innryk"
  },
  "increase_rich_content_area_340b775": {
    "message": "Øk Rich innholdsområde"
  },
  "indefinite_integral_6623307e": {
    "message": "Ubestemt heltall"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } av { max }"
  },
  "indigo_2035fc55": {
    "message": "Indigo"
  },
  "inference_fed5c960": {
    "message": "Inferens"
  },
  "infinity_7a10f206": {
    "message": "Uendelig"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Inndatafelt for alfa"
  },
  "input_field_for_blue_561e020a": {
    "message": "Inndatafelt for blå"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Inndatafelt for grønn"
  },
  "input_field_for_red_86a84615": {
    "message": "Inndatafelt for rød"
  },
  "insert_593145ef": {
    "message": "Sett inn"
  },
  "insert_link_6dc23cae": {
    "message": "Sett inn lenke"
  },
  "insert_math_equation_57c6e767": {
    "message": "Sett matte likning"
  },
  "integers_336344e1": {
    "message": "Heltall"
  },
  "intersection_cd4590e4": {
    "message": "Kryss"
  },
  "invalid_description_991e23bb": {
    "message": "Ugyldig beskrivelse"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Ugyldig oppføring."
  },
  "invalid_file_c11ba11": {
    "message": "Ugyldig fil"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Ugyldig filtype"
  },
  "invalid_url_cbde79f": {
    "message": "Ugyldig URL"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "Problem { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Kursiv aktivert"
  },
  "italic_removed_17cbab6f": {
    "message": "Kursiv fjernet"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (variant)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Snarveier"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Tastatur navigerer til lenker ved å bruke tabulatortasten. To lenker som viser til samme destinasjon kan være forvirrende for tastaturbrukere."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Språkkunst-ikon"
  },
  "languages_icon_9d20539": {
    "message": "Språk-ikon"
  },
  "large_9c5e80e7": {
    "message": "Stor"
  },
  "large_text_e7ba08cd": {
    "message": "Stor tekst"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Stor ({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "Lær"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Lær mer om lenker ved siden av"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Lær mer om fargekontrast"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Lær mer om hvordan organisere sideoverskrifter"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Lær mer om riktig sideoverskriftsstruktur"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Lær mer om tabelloverskrifter"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Lær mer om hvordan bruke alt tekst for bilder"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Lær mer om hvordan bruke bildetekst med tabeller"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Lær mer om hvordan bruke filnavn som alt tekst"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Lær mer om hvordan bruke lister"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Lær mer om hvordan bruke omfangsatributter med tabeller"
  },
  "leave_as_is_4facfe55": {
    "message": "La det være"
  },
  "left_3ea9d375": {
    "message": "Venstre"
  },
  "left_align_43d95491": {
    "message": "Venstrestilt"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Venstre vinkelparantes"
  },
  "left_arrow_4fde1a64": {
    "message": "Venstre pil"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Venstre pil med krok"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Venstre tak"
  },
  "left_curly_brace_1726fb4": {
    "message": "Venstre krøllparantes"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Harpun ned med krok til venstre"
  },
  "left_floor_29ac2274": {
    "message": "Venstre gulv"
  },
  "left_to_right_e9b4fd06": {
    "message": "Venstre-til-høyre"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Harpun opp med krok til venstre"
  },
  "leftward_arrow_1e4765de": {
    "message": "Pil mot venstre"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Trekant som peker mot venstre"
  },
  "less_than_a26c0641": {
    "message": "Mindre enn"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Mindre enn eller lik"
  },
  "library_icon_ae1e54cf": {
    "message": "Bibliotek-ikon"
  },
  "light_blue_5374f600": {
    "message": "Lyseblå"
  },
  "link_7262adec": {
    "message": "Lenke"
  },
  "link_options_a16b758b": {
    "message": "Lenkevalg"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "lenketype: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Lenke med tekst som starter med { start }"
  },
  "links_14b70841": {
    "message": "Lenker"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Lenker til en ekstern side."
  },
  "lists_cd1336fc": {
    "message": "Lister"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Lister må formateres som lister."
  },
  "load_more_35d33c7": {
    "message": "Last inn mer"
  },
  "loading_25990131": {
    "message": "Laster…"
  },
  "loading_bde52856": {
    "message": "Laster"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "lasting av teksting/underteksting mislyktes."
  },
  "loading_external_tool_d839042c": {
    "message": "Laster inn eksternt verktøy"
  },
  "loading_failed_b3524381": {
    "message": "Lasting mislyktes…"
  },
  "loading_failed_e6a9d8ef": {
    "message": "Lasting mislyktes."
  },
  "loading_folders_d8b5869e": {
    "message": "Laster mapper"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Laster inn plassholder for { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Laster inn, vennligst vent"
  },
  "loading_preview_9f077aa1": {
    "message": "Laster forhåndsvisning"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Lås hastighet til x1"
  },
  "locked_762f138b": {
    "message": "Låst"
  },
  "logical_equivalence_76fca396": {
    "message": "Logisk ekvivalens"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Logisk ekvivalens (kort)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Logisk ekvivalens (kort og tykk)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Logisk ekvivalens (tykk)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Lave horisontale prikker"
  },
  "magenta_4a65993c": {
    "message": "Magenta"
  },
  "maps_to_e5ef7382": {
    "message": "Peker mot"
  },
  "math_icon_ad4e9d03": {
    "message": "Matte-ikon"
  },
  "media_af190855": {
    "message": "Medie"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Mediefilen behandles. Prøv igjen senere."
  },
  "media_options_saved_560c4ec8": {
    "message": "Mediealternativer lagret."
  },
  "media_title_2112243b": {
    "message": "Medietittel"
  },
  "medium_5a8e9ead": {
    "message": "Medium"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Middels ({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "Slå sammen lenker"
  },
  "mic_a7f3d311": {
    "message": "Mikrofon"
  },
  "microphone_disabled_15c83130": {
    "message": "Mikrofon deaktivert"
  },
  "middle_27dc1d5": {
    "message": "Midten"
  },
  "minimize_file_preview_da911944": {
    "message": "Minimer forhåndsvisning av fil"
  },
  "minimize_video_20aa554b": {
    "message": "Minimer video"
  },
  "minus_fd961e2e": {
    "message": "Minus"
  },
  "minus_plus_3461f637": {
    "message": "Minus/pluss"
  },
  "misc_3b692ea7": {
    "message": "Diverse"
  },
  "miscellaneous_e9818229": {
    "message": "Diverse"
  },
  "module_90d9fd32": {
    "message": "Modul"
  },
  "modules_c4325335": {
    "message": "Moduler"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Flytter bilde for å beskjære { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Bilde i flere farger"
  },
  "multiplication_sign_15f95c22": {
    "message": "Multiplikasjonstegn"
  },
  "music_icon_4db5c972": {
    "message": "Musikk-ikon"
  },
  "my_files_2f621040": {
    "message": "Mine filer"
  },
  "n_th_root_9991a6e4": {
    "message": "n-te rot"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Navn"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Naturlig (musikk)"
  },
  "natural_numbers_3da07060": {
    "message": "Naturlige tall"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Navigere gjennom menyen eller verktøylinjen"
  },
  "navigation_ee9af92d": {
    "message": "Navigasjon"
  },
  "nested_greater_than_d852e60d": {
    "message": "Nested større enn"
  },
  "nested_less_than_27d17e58": {
    "message": "Nested mindre enn"
  },
  "new_quiz_34aacba6": {
    "message": "Ny quiz"
  },
  "next_40e12421": {
    "message": "Neste"
  },
  "next_findtext_9d69f0fe": {
    "message": "Neste { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Ingen tiljengelighetsproblemer ble oppdaget."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Ingen beskjeder opprettet ennå."
  },
  "no_announcements_found_20185afc": {
    "message": "Ingen beskjeder funnet."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Ingen oppgave opprettet ennå."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Ingen oppgaver funnet."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Ingen endringer å lagre."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Ingen diskusjoner opprettet ennå."
  },
  "no_discussions_found_9284063b": {
    "message": "Ingen diskusjoner funnet."
  },
  "no_e16d9132": {
    "message": "Nei"
  },
  "no_file_chosen_9a880793": {
    "message": "Ingen fil valgt"
  },
  "no_headers_9bc7dc7f": {
    "message": "Ingen titler"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Ingen moduler opprettet ennå."
  },
  "no_modules_found_2df43a40": {
    "message": "Ingen moduler funnet."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Ingen sider opprettet ennå."
  },
  "no_pages_found_6799350": {
    "message": "Ingen sider funnet."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Ingen forhåndsvisning er tilgjengelig for denne filen."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Ingen quizer opprettet ennå."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Ingen quizer funnet."
  },
  "no_results_940393cf": {
    "message": "Ingen resultater."
  },
  "no_results_found_58717065": {
    "message": "Ingen resultater ble funnet"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Ingen resultat funnet for { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Ingen video"
  },
  "none_3b5e34d2": {
    "message": "Ingen"
  },
  "none_selected_b93d56d2": {
    "message": "Ingen valgt"
  },
  "normal_text_7b03da48": {
    "message": "Normal tekst"
  },
  "not_equal_6e2980e6": {
    "message": "Ikke lik"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Ikke i (ikke et element av)"
  },
  "not_negation_1418ebb8": {
    "message": "Ikke (negasjon)"
  },
  "not_subset_dc2b5e84": {
    "message": "Ikke delsett"
  },
  "not_subset_strict_23d282bf": {
    "message": "Ikke delsett (streng)"
  },
  "not_superset_5556b913": {
    "message": "Ikke supersett"
  },
  "not_superset_strict_24e06f36": {
    "message": "Ikke supersett (streng)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "Åttekant"
  },
  "olive_6a3e4d6b": {
    "message": "Oliven"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "En av følgende stiler må legges til for å lagre et ikon: Ikonfarge, konturstørrelse, ikontekst eller bilde"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Én eller flere filer kunne ikke limes inn. Prøv å laste opp eller dra og slippe filer."
  },
  "open_circle_e9bd069": {
    "message": "Åpen sirkel"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Åpne denne hurtigtastdialogen"
  },
  "open_title_application_fd624fc5": {
    "message": "Åpne { title }-applikasjon"
  },
  "operators_a2ef9a93": {
    "message": "Operatører"
  },
  "options_3ab0ea65": {
    "message": "Valg"
  },
  "or_9b70ccaa": {
    "message": "Eller"
  },
  "orange_81386a62": {
    "message": "Oransje"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Ordnede og uordnede lister"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Andre redigeringssnarveier kan sees på"
  },
  "outline_color_3ef2cea7": {
    "message": "Farge omriss"
  },
  "outline_size_a6059a21": {
    "message": "Størrelse omriss"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } er ikke en gyldig protokoll."
  },
  "page_50c4823d": {
    "message": "Side"
  },
  "pages_e5414c2c": {
    "message": "Sider"
  },
  "paragraph_5e5ad8eb": {
    "message": "Avsnitt"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Avsnitt aktivert"
  },
  "paragraph_removed_d09320e": {
    "message": "Avsnitt fjernet"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Setning som starter med { start }"
  },
  "parallel_d55d6e38": {
    "message": "Parallell"
  },
  "partial_derivative_4a9159df": {
    "message": "Delvis (derivat)"
  },
  "pass_1c19a2b3": {
    "message": "BESTÅTT"
  },
  "paste_5963d1c1": {
    "message": "Lim inn"
  },
  "pause_12af3bb4": {
    "message": "Pause"
  },
  "pentagon_17d82ea3": {
    "message": "Femkant"
  },
  "people_b4ebb13c": {
    "message": "Deltakere"
  },
  "percentage_34ab7c2c": {
    "message": "Prosent"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Prosent må være et tall"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Prosent må være minst { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Scenekunst-ikon"
  },
  "perpendicular_7c48ede4": {
    "message": "Vinkelrett"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi (variant)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Gymnastikk-ikon"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (variant)"
  },
  "pick_a_color_557abfb0": {
    "message": "Velg en farge"
  },
  "pink_68ad45cb": {
    "message": "Rosa"
  },
  "pixels_52ece7d1": {
    "message": "Piksler"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Piksler må være minst { width } x { height } px"
  },
  "play_1a47eaa7": {
    "message": "Spill av"
  },
  "play_media_comment_35257210": {
    "message": "Spill mediainnhold"
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Spill mediainnhold av { name } fra { createdAt }."
  },
  "player_layout_14e09a29": {
    "message": "Spilleroppsett"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Gi Canvas tilgang til mikrofonen og webkameraet ditt."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Velg en fil"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Skriv inn et filnavn"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Angi en gyldig video-URL fra en støttet plattform."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Velg en fil av støttet filtype"
  },
  "plus_d43cd4ec": {
    "message": "Pluss"
  },
  "plus_minus_f8be2e83": {
    "message": "Pluss/minus"
  },
  "posted_when_a578f5ab": {
    "message": "Publisert: { when }"
  },
  "power_set_4f26f316": {
    "message": "Potens-sett"
  },
  "precedes_196b9aef": {
    "message": "Forutgående"
  },
  "precedes_equal_20701e84": {
    "message": "Går foran lik"
  },
  "preformatted_d0670862": {
    "message": "Forhåndsformattert"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Forrige"
  },
  "preview_53003fd2": {
    "message": "Forhåndsvisning"
  },
  "preview_a3f8f854": {
    "message": "FORHÅNDSVISNING"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Forhåndsvis i utvidet vindu"
  },
  "preview_inline_9787330": {
    "message": "Forhåndsvis i vindu"
  },
  "previous_bd2ac015": {
    "message": "Forrige"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Forrige { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Tidligere valgte farger"
  },
  "prime_917ea60e": {
    "message": "Prim"
  },
  "prime_numbers_13464f61": {
    "message": "Primtall"
  },
  "product_39cf144f": {
    "message": "Produkt"
  },
  "proportional_f02800cc": {
    "message": "Proporsjonal"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Protokollen må være ftp, http, https, mailto, skype, tel eller kan utelates"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "publisert"
  },
  "published_when_302d8e23": {
    "message": "Publisert: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Gresskar"
  },
  "purple_7678a9fc": {
    "message": "Lilla"
  },
  "quaternions_877024e0": {
    "message": "Kvaternioner"
  },
  "quiz_e0dcce8f": {
    "message": "Quiz"
  },
  "quizzes_7e598f57": {
    "message": "Quizer"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Rasjonelle tall"
  },
  "real_numbers_7c99df94": {
    "message": "Reelle tall"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Reell del (av komplekst tall)"
  },
  "record_7c9448b": {
    "message": "Registrering"
  },
  "record_upload_media_5fdce166": {
    "message": "Ta opp/last opp media"
  },
  "recording_98da6bda": {
    "message": "Opptak"
  },
  "red_8258edf3": {
    "message": "Rød"
  },
  "relationships_6602af70": {
    "message": "Forbindelser"
  },
  "religion_icon_246e0be1": {
    "message": "Religion-ikon"
  },
  "remove_f47dc62a": {
    "message": "Fjern"
  },
  "remove_filename_3ea029f6": {
    "message": "Fjern { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Fjern tittelstil"
  },
  "remove_link_d1f2f4d0": {
    "message": "Fjerne lenke"
  },
  "replace_all_d3d68b3": {
    "message": "Erstatt alle"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Erstatt alle { findText } med { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Erstatt"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Erstatt { findText } med { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Erstatt med"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Erstattet { alertFindText } med { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Erstattet alle { alertFindText } med { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Tilbakestill"
  },
  "resize_ec83d538": {
    "message": "Endre størrelse"
  },
  "restore_auto_save_deccd84b": {
    "message": "Gjenopprette automatisk lagring?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Resultat { index } av { max }."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Omvendt turnstile (gir ikke etter)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (variant)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Rich teksteditor"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Rikt tekstområde Trykk { OSKey }+F8 for snarveier i Rich innholdsredigering."
  },
  "right_71ffdc4d": {
    "message": "Høyre"
  },
  "right_align_39e7a32a": {
    "message": "Høyrestilt"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Høyre vinkelparantes"
  },
  "right_arrow_35e0eddf": {
    "message": "Høyre pil"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Høyre pil med krok"
  },
  "right_ceiling_839dc744": {
    "message": "Høyre tak"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Høyre krøllparantes"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Harpun ned med krok til høyre"
  },
  "right_floor_5392d5cf": {
    "message": "Høyre gulv"
  },
  "right_to_left_9cfb092a": {
    "message": "Høyre-til-venstre"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Harpun opp med krok til høyre"
  },
  "rightward_arrow_32932107": {
    "message": "Pil mot høyre"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Trekant som peker mot høyre"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Roter bildet -90 grader"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Roter bildet 90 grader"
  },
  "rotation_9699c538": {
    "message": "Rotasjon"
  },
  "row_fc0944a7": {
    "message": "Rad"
  },
  "row_group_979f5528": {
    "message": "Radgruppe"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Dessverre er Elegante HTML-redigering ikke tilgjengelig med tastaturet. Få tilgang til rå HTML-redigering her."
  },
  "save_11a80ec3": {
    "message": "Lagre"
  },
  "save_copy_ca63944e": {
    "message": "Lagre kopi"
  },
  "save_media_cb9e786e": {
    "message": "Lagre media"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Lagrede Ikonskaper-ikoner"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Skjermlesere kan ikke avgjøre hva som vises i et bilde uten alternativ tekst, og filnavn er ofte meningsløse strenger av bokstaver og siffer som ikke beskriver konteksten eller meningen."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Skjermlesere kan ikke avgjøre hva som vises i et bilde uten alternativ tekst som beskriver innholdet og meningen med bildet. Alternativ tekst bør være kort og konsis."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Skjermlesere kan ikke avgjøre hva som vises i et bilde uten alternativ tekst som beskriver innholdet og meningen med bildet."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Skjermlesere kan ikke tolke tabeller uten skikkelig struktur. Tabelltitler gir rettledning og indikerer innholdsomfang"
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Skjermlesere kan ikke tolke tabeller uten skikkelig struktur. Tabelloverskrifter beskriver konteksten og den generelle forståelsen av tabellen."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Skjermlesere kan ikke tolke tabeller uten skikkelig struktur. Tabelltitler gir rettledning og  oversikt over innholdet."
  },
  "script_l_42a7b254": {
    "message": "Skript L"
  },
  "search_280d00bd": {
    "message": "Søk"
  },
  "select_audio_source_21043cd5": {
    "message": "Velg lydkilde"
  },
  "select_crop_shape_d441feeb": {
    "message": "Velg beskjæringsform"
  },
  "select_language_7c93a900": {
    "message": "Velg språk"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Velg videokilde"
  },
  "selected_274ce24f": {
    "message": "Valgt"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Valgt { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Valg"
  },
  "set_header_scope_8c548f40": {
    "message": "Sett tittelomfang"
  },
  "set_minus_b46e9b88": {
    "message": "Angi minus"
  },
  "set_table_header_cfab13a0": {
    "message": "Sett tabelltittel"
  },
  "sharp_music_ab956814": {
    "message": "Sharp/iss (musikk)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+piltaster"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Skift-O for å åpne elegante html-redigering."
  },
  "shortcut_911d6255": {
    "message": "Snarvei"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Vis bildemuligheter"
  },
  "show_link_options_545338fd": {
    "message": "Vis lenkevalg"
  },
  "show_rolling_transcript_c1481744": {
    "message": "Vis rullende transkripsjon"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "Vis rullende transkripsjon"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Seende brukere surfer nettsider kjapt, og ser etter store eller uthevede titler. Brukere av skjermlesere er avhengige av titler for å forstå konteksten. Titler bør bruke korrekt struktur."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Seende brukere surfer nettsider kjapt, og ser etter store eller uthevede titler. Brukere av skjermlesere er avhengige av titler for å forstå konteksten. Titler bør være konsise innenfor den korrekte strukturen."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (variant)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Enkeltfargebilde"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Enkeltfargebilde-farge"
  },
  "size_b30e1077": {
    "message": "Størrelse"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Størrelsen på bildetekstfilen er større en maksimalt tillatt størrelse på { max } kb."
  },
  "small_b070434a": {
    "message": "Liten"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Liten ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "Solid sirkel"
  },
  "something_went_wrong_89195131": {
    "message": "Noe gikk galt."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Det oppsto en feil under åpning av webkameraet."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Noe gikk galt og jeg vet ikke hva jeg skal vise deg."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Noe gikk galt. Kontroller tilkoblingen din, last inn siden på nytt og prøv igjen."
  },
  "something_went_wrong_d238c551": {
    "message": "Noe gikk galt"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Noe gikk galt under deling av skjermen din."
  },
  "sort_by_e75f9e3e": {
    "message": "Sortert på"
  },
  "spades_suit_b37020c2": {
    "message": "Spar (type)"
  },
  "square_511eb3b3": {
    "message": "Square"
  },
  "square_cap_9ec88646": {
    "message": "Firkantet caps"
  },
  "square_cup_b0665113": {
    "message": "Firkantet kopp"
  },
  "square_root_e8bcbc60": {
    "message": "Kvadratrot"
  },
  "square_root_symbol_d0898a53": {
    "message": "Kvadratrotsymbol"
  },
  "square_subset_17be67cb": {
    "message": "Kvadratisk delsett"
  },
  "square_subset_strict_7044e84f": {
    "message": "Kvadratisk delsett (streng)"
  },
  "square_superset_3be8dae1": {
    "message": "Kvadratisk supersett"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Kvadratisk supersett (streng)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "firkantet uordnet liste"
  },
  "star_8d156e09": {
    "message": "Stjernemerke"
  },
  "start_over_f7552aa9": {
    "message": "Start på nytt"
  },
  "start_recording_9a65141a": {
    "message": "Start opptak"
  },
  "steel_blue_14296f08": {
    "message": "Stålblå"
  },
  "studio_media_options_ee504361": {
    "message": "Studiomediealternativer"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Skuff for studiomediealternativer"
  },
  "styles_2aa721ef": {
    "message": "Stiler"
  },
  "submit_a3cc6859": {
    "message": "Send inn"
  },
  "submitting_b90fac62": {
    "message": "Sender inn…"
  },
  "subscript_59744f96": {
    "message": "Senket skrift"
  },
  "subset_19c1a92f": {
    "message": "Delsett"
  },
  "subset_strict_8d8948d6": {
    "message": "Delsett (streng)"
  },
  "succeeds_9cc31be9": {
    "message": "Lykkes"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Lykkes er lik"
  },
  "sum_b0842d31": {
    "message": "Sum"
  },
  "superscript_8cb349a2": {
    "message": "Hevet skrift"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Hevet og nedsenket"
  },
  "superset_c4db8a7a": {
    "message": "Supersett"
  },
  "superset_strict_c77dd6d2": {
    "message": "Supersett (streng)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Filtyper som støttes: SRT eller WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Bytt til elegant HTML-redigerer"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Bytt til rå HTML-redigerer"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Bytt til html-redigering"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Bytt til rich tekstredigering"
  },
  "syllabus_f191f65b": {
    "message": "Fagoversikt"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Systemlyd tillatt"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Systemlyd deaktivert"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/piltaster"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Tabelltittel starter med { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Tabell starter med { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Tabelltitler bør spesifisere omfang."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Tabeller bør inkludere en overskrift som beskriver innholdet i tabellen."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Tabeller bør inkludere minst en tittel."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Blågrønn"
  },
  "text_7f4593da": {
    "message": "Tekst"
  },
  "text_background_color_16e61c3f": {
    "message": "Bakgrunnsfarge tekst"
  },
  "text_color_acf75eb6": {
    "message": "Tekstfarge"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Teksten er vanskelig å lese uten tilstrekkelig kontrast mellom tekst og bakgrunn, spesielt for svaksynte."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "Tekst større enn 18pkt (eller tykk 14pkt) bør vises med en minimums kontrastrate på 3:1."
  },
  "text_optional_384f94f7": {
    "message": "Tekst (valgfritt)"
  },
  "text_position_8df8c162": {
    "message": "Tekstposisjon"
  },
  "text_size_887c2f6": {
    "message": "Tekststørrelse"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "Tekst mindre enn 18pkt (eller tykk 14pkt) bør vises med en minimums kontrastrate på 4,5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Dokumentforhåndsvisningen behandles. Prøv igjen senere."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "Den første overskriften på en side skal være en H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "Høyden av Rich innholdsområde er redusert."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "Høyden av Rich innholdsområde er økt."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Materialet er i det offentlige domenet"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Materialet er lisensiert under Creative Commons"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "Dette materialet er underlagt et unntak - f.eks. fair use, retten til å sitere eller andre i henhold til gjeldende lover for opphavsrett"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "Elegante HTML-redigering ikke tilgjengelig med tastaturet. Trykk Skift-O for å åpne rå html-redigering."
  },
  "therefore_d860e024": {
    "message": "Derfor"
  },
  "theta_ce2d2350": {
    "message": "Theta"
  },
  "theta_variant_fff6da6f": {
    "message": "Theta (variant)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Tykk pil nedover"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Tykk pil til venstre"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Tykk pil mot venstre"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Tykk pil til høyre"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Tykk pil mot høyre"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Tykk pil oppover"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Dette dokumentet kan ikke vises i Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Denne ligningen kan ikke legges frem i enkel visning."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Dette bildet er utilgjengelig for øyeblikket"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "Denne videoen kan vise YouTube-annonser."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Selv om videoen din har riktig titten i nettleseren kunne vi ikke oppdatere den i databasen."
  },
  "thumbnail_e0de666f": {
    "message": "Miniatyrbilde"
  },
  "timebar_a4d18443": {
    "message": "Tidsbar"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "Tittelen kan ikke være tom"
  },
  "title_ee03d132": {
    "message": "Tittel"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "Skal publiseres: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Gjøremål: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Veksle { summary }-gruppe"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Bytte verktøytips"
  },
  "tools_2fcf772e": {
    "message": "Verktøy"
  },
  "top_66e0adb6": {
    "message": "Topp"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "Transkripsjonspanelet er tilgjengelig i bredder over 720 piksler."
  },
  "tray_839df38a": {
    "message": "Brett"
  },
  "triangle_6072304e": {
    "message": "Trekant"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Turnstile (gir etter)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "Tast Kontroll F9 for å få tilgang til bilde-alternativer. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "Tast Kontroll F9 for å få tilgang til link-alternativer. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "Tast Kontroll F9 for å få tilgang til tabell-alternativer. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Kan ikke bestemme nettadressen for valg av ressurs"
  },
  "underline_applied_ae01ec97": {
    "message": "Understrek aktivert"
  },
  "underline_removed_3693e17c": {
    "message": "Understrek fjernet"
  },
  "union_e6b57a53": {
    "message": "Union"
  },
  "unpublished_dfd8801": {
    "message": "upublisert"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "Alle ulagrede endringer vil gå tapt."
  },
  "untitled_16aa4f2b": {
    "message": "Uten navn"
  },
  "untitled_efdc2d7d": {
    "message": "uten navn"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Diagonal pil opp mot venstre"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Diagonal pil opp mot høyre"
  },
  "up_c553575d": {
    "message": "Opp"
  },
  "updated_link_a827e441": {
    "message": "Oppdatert lenke"
  },
  "upload_document_253f0478": {
    "message": "Last opp dokument"
  },
  "upload_file_fd2361b8": {
    "message": "Last opp fil"
  },
  "upload_image_6120b609": {
    "message": "Last opp bilde"
  },
  "upload_media_ce31135a": {
    "message": "Laste opp medier"
  },
  "upload_record_media_e4207d72": {
    "message": "Laste opp/ spille inn medier"
  },
  "uploading_19e8a4e7": {
    "message": "Laster opp"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "stor bokstav alfabetisert organisert liste"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Stor delta"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Stor gamma"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Stor lambda"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Stor omega"
  },
  "uppercase_phi_caa36724": {
    "message": "Stor phi"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Stor pi"
  },
  "uppercase_psi_6395acbe": {
    "message": "Stor psi"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "stor bokstav romertall organisert liste"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Stor sigma"
  },
  "uppercase_theta_49afc891": {
    "message": "Stor theta"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Stor upsilon"
  },
  "uppercase_xi_341e8556": {
    "message": "Stor xi"
  },
  "upsilon_33651634": {
    "message": "Upsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Pil som peker oppover og nedover"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Pil som peker oppover og nedover (tykk)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Pil oppover"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Trekant som peker oppover"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Bruksrettigheter:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Bruksrettigheter (påkrevd)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Bruk piltaster for å navigere i valgene."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Bruk piltastene for å velge en form."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Bruk piltastene for å velge en størrelse."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Bruk piltastene for å velge en tekstposisjon."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Bruk piltastene for å velge en tekststørrelse."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Bruk piltastene for å velge størrelse på omriss."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Brukt av skjermlesere for å beskrive innholdet til et { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Brukt av skjermlesere for å beskrive innholdet til et bilde"
  },
  "user_documents_c206e61f": {
    "message": "Brukerdokumenter"
  },
  "user_files_78e21703": {
    "message": "Brukerfiler"
  },
  "user_images_b6490852": {
    "message": "Brukerbilder"
  },
  "user_media_14fbf656": {
    "message": "Brukermedie"
  },
  "vector_notation_cf6086ab": {
    "message": "Vektor (notasjon)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Vertikal linje (set builder-notasjon)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Vertikale prikker"
  },
  "video_options_24ef6e5d": {
    "message": "Videovalg"
  },
  "video_options_tray_3b9809a5": {
    "message": "Videovalgbrett"
  },
  "video_player_b371005": {
    "message": "Video avspiller"
  },
  "video_player_for_9e7d373b": {
    "message": "Video avspiller for "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Video avspiller for { title }"
  },
  "video_url_889d3263": {
    "message": "Video-URL"
  },
  "view_all_e13bf0a6": {
    "message": "Vis alle"
  },
  "view_ba339f93": {
    "message": "Vis"
  },
  "view_description_30446afc": {
    "message": "Vis beskrivelse"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Vis tastatur-snarveier"
  },
  "view_title_description_67940918": {
    "message": "Vis { title }-beskrivelse"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Vis antall ord og tegn"
  },
  "viewer_restrictions_e14274c9": {
    "message": "Seerbegrensninger"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Vi kunne ikke oppdage en fungerende mikrofon som er koblet til enheten din."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Vi kunne ikke oppdage et fungerende webkamera som er koblet til enheten din."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Vi kunne ikke oppdage et fungerende webkamera eller mikrofon som er koblet til enheten din."
  },
  "webcam_disabled_30c66986": {
    "message": "Webkamera deaktivert"
  },
  "webcam_fe91b20f": {
    "message": "Webkamera"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Nettsider skal bare ha en enkel H1, som automatisk brukes av sidens tilttel. Den første overskriften i innholdet ditt skal være en H2."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Når det brukes markering som visuelt formaterer elementer som en liste men ikke indikerer et listeforhold kan brukere finne det vanskelig å navigere informasjonen."
  },
  "white_87fa64fd": {
    "message": "Hvit"
  },
  "why_523b3d8c": {
    "message": "Hvorfor"
  },
  "width_492fec76": {
    "message": "Bredd"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Bredde og høyde må være nummer"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "Wikiforside"
  },
  "word_count_c77fe3a6": {
    "message": "Ordtelling"
  },
  "words_b448b7d5": {
    "message": "Ord"
  },
  "wreath_product_200b38ef": {
    "message": "Kransprodukt"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Ja"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Du er på en fargepalett For å navigere opp, venstre, ned eller høyre på paletten, bruk henholdsvis «W»-, «A»-, «S»- og «D»-knappene"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Du er på en fargeglidebryter. For å navigere til venstre eller høyre på glidebryteren, bruk henholdsvis «A»- og «D»-knappene"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Du er på en alfaglidebryter. For å navigere til venstre eller høyre på glidebryteren, bruk henholdsvis «A»- og «D»-knappene"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Du har ulagrede endringer i Ikonskaper-skuffen. Vil du fortsette uten å lagre disse?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Du må kanskje justere flere overskrifter for å opprettholde sidehierarkiet."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Du kan ikke laste opp en tom fil."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Bildet ditt har blitt komprimert for Ikonskaper. Bilder mindre enn { size } KB blir ikke komprimert."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Mikrofonen din er blokkert i nettleserinnstillingene."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Webkameraet og mikrofonen er blokkert i nettleserinnstillingene."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Webkameraet ditt er blokkert i nettleserinnstillingene."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Webkameraet ditt kan allerede være i bruk."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "YouTube-innebygd URL"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Zoom inn bildet"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Zoom ut bildet"
  }
};
formatMessage.addLocale({
  'nb-x-k12': locale
});